import styled from 'styled-components';
import { variables } from '@splunk/themes';

export const PaddedContainer = styled.div`
    // top & bottom padding
    padding-block: ${variables.spacingLarge}; // left & right padding
    padding-inline: ${variables.spacingLarge};
    // first child should have same top padding as sides
    &:first-child {
        padding-top: ${variables.spacingLarge};
    }
    // last child should have same bottom padding as sides
    &:last-child {
        padding-bottom: ${variables.spacingLarge};
    }
`;
